import { render } from "./new_role.vue?vue&type=template&id=ab82bb18&scoped=true"
import script from "./new_role.vue?vue&type=script&lang=js"
export * from "./new_role.vue?vue&type=script&lang=js"

import "./new_role.vue?vue&type=style&index=0&id=ab82bb18&scoped=true&lang=css"

import exportComponent from "/Volumes/Whisper/Development/projects/sid/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab82bb18"]])

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../../../../Volumes/Whisper/Development/projects/sid/ui/node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSelect,QInput,QBtn});
